import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const [username, setUsername] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const updateUsername = () => {
      const storedUsername = localStorage.getItem('name');
      setUsername(storedUsername);
    };

    updateUsername(); // initial load

    window.addEventListener('usernameChanged', updateUsername);
    return () => window.removeEventListener('usernameChanged', updateUsername);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('name');
    setUsername(null);
    console.log('User logged out');
    console.log('clear localStorage');
    navigate('/login');
  };

  return (
    <div className="navbar">
      <div className="logo">
        <Link to="/dashboard">
          <h1 className="navh1">SecureChat</h1>
        </Link>
      </div>

      <div className="nav-right">
        {username ? (
          <>
            <span className="username-display">{username}</span>
            <button className="logout-btn" onClick={handleLogout}>
              Logout
            </button>
          </>
        ) : (
          <Link to="/login">
            <button className="login-btn">Login</button>
          </Link>
        )}
      </div>
    </div>
  );
}
